import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ApplicationService } from '../application/application.service';
import { Script } from '../interfaces/script';
import { RunScriptComponent } from '../application/run-script/run-script.component';
import { EmptyStateModule } from '@michelin/theme';

@Component({
  selector: 'mic-app-homescript',
  templateUrl: './homescript.component.html',
  styleUrls: ['./homescript.component.scss'],
  imports: [RunScriptComponent, EmptyStateModule]
})
export class HomescriptComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly appService = inject(ApplicationService);

  scripts: Script[] = [];

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      if (params['name'] !== 'hbi') {
        this.appService.getApplicationByName(this.route.snapshot.params['name']).subscribe((response) => {
          this.scripts = response.scripts;
        });
      } else {
        this.router.navigate(['../'], { relativeTo: this.route });
      }
    });
  }
}
